import { useState } from "react";
import { apiFetch } from "../api";
import { trackEvent } from "../analytics/posthog";
import s from "./SignupPage.module.css";

export default function SignupPage({ onSuccess, onBack, onLogin }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const obRaw = localStorage.getItem("onboarding_data");
      const ob = obRaw ? JSON.parse(obRaw) : {};
      const res = await apiFetch("/api/v1/auth/sign-up", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          country_of_origin: ob.country || null,
          swedish_level: ob.level || null,
          referral_source: ob.referral || null,
        }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => null);
        throw new Error(data?.detail || "Something went wrong");
      }

      const data = await res.json();
      trackEvent("sign_up");
      onSuccess(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={s.page}>
      <div className={s.card}>
        <button className={s.back} onClick={onBack}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5" />
            <path d="M12 19l-7-7 7-7" />
          </svg>
          Back
        </button>

        <div className={s.shieldWrap}>
          <div className={s.shield}>
            <svg className={s.shieldIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
              <path d="M2 12l10 5 10-5" />
            </svg>
          </div>
        </div>

        <h1 className={s.title}>Start your journey</h1>
        <p className={s.subtitle}>Create your account and begin learning Swedish</p>

        <div className={s.divider}>
          <div className={s.dividerLine} />
          <div className={s.dividerDot} />
          <div className={s.dividerLine} />
        </div>

        <form onSubmit={handleSubmit}>
          <div className={s.fieldGroup}>
            <div className={s.field}>
              <label className={s.fieldLabel}>Email</label>
              <input
                className={s.fieldInput}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoComplete="email"
                autoFocus
              />
            </div>
          </div>

          {error && (
            <div className={s.error}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
              {error}
            </div>
          )}

          <button type="submit" className={s.submitBtn} disabled={loading}>
            {loading ? (
              <span className={s.btnLoading}>
                <span className={s.btnSpinner} />
                Creating account...
              </span>
            ) : (
              "Begin Your Quest"
            )}
          </button>
        </form>

        <p className={s.loginLink}>
          Already have an account?{" "}
          <button className={s.loginBtn} onClick={onLogin}>
            Sign in
          </button>
        </p>

        <div className={s.badges}>
          <div className={s.badge}>
            <div className={`${s.badgeIcon} ${s.badgeIconAmber}`}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20V10" />
                <path d="M18 20V4" />
                <path d="M6 20v-4" />
              </svg>
            </div>
            <span className={s.badgeLabel}>Quests</span>
          </div>

          <div className={s.badge}>
            <div className={`${s.badgeIcon} ${s.badgeIconIndigo}`}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
              </svg>
            </div>
            <span className={s.badgeLabel}>Stories</span>
          </div>

          <div className={s.badge}>
            <div className={`${s.badgeIcon} ${s.badgeIconGold}`}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
            </div>
            <span className={s.badgeLabel}>XP Stars</span>
          </div>
        </div>
      </div>
    </div>
  );
}
